import {ReactElement, ReactNode} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {Locale} from '../../../../../../../../provider/locale/locale';
import {LocaleNameEnum} from '../../../../../../../../provider/locale/locale-context-type';
import {
    HistoryReplyItemType,
    ReviewReplyHistoryActionEnum,
} from '../../../../../../../../service/reviews/reviews-history-helper-type';
import {getDateTimeDifferenceHumanSize} from '../../../../../../../../util/time';

import {HistoryReplyLog} from './history-reply-log';

type PropsType = {
    formattedDate: string | null;
    formattedTime: string | null;
    log: HistoryReplyItemType;
    localeName: LocaleNameEnum;
    reviewCreatedInCatalog: string;
    userName: string;
};

function getReplyResponseTime(props: PropsType): ReactNode {
    const {log, localeName, reviewCreatedInCatalog} = props;

    if (log.action !== ReviewReplyHistoryActionEnum.Created || !reviewCreatedInCatalog) {
        return null;
    }

    const replyResponseTimeSeconds = Math.max(
        0,
        (new Date(log.loggedAt).getTime() - new Date(reviewCreatedInCatalog).getTime()) / 1000
    );

    if (replyResponseTimeSeconds <= 0) {
        return null;
    }

    return (
        <Text
            lighter
            stringKey="REVIEW__RESPONSE_TIME"
            valueMap={{
                time:
                    replyResponseTimeSeconds < 60 ? (
                        <Locale stringKey="REVIEWS__RESPONSE_TIME__DURING_MINUTE" />
                    ) : (
                        getDateTimeDifferenceHumanSize({
                            milliseconds: replyResponseTimeSeconds * 1000,
                            sliceSize: 2,
                            localeName,
                        })
                    ),
            }}
        />
    );
}

export function getHistoryReplyTimelineItem(props: PropsType): {children: ReactElement} {
    const {formattedDate, formattedTime, log, userName} = props;

    return {
        children: (
            <HistoryReplyLog
                formattedDate={formattedDate}
                formattedTime={formattedTime}
                item={log}
                responseTime={getReplyResponseTime(props)}
                userName={userName}
            />
        ),
    };
}
